// extracted by mini-css-extract-plugin
export default {"SiteInfo":"SiteInfo_SiteInfo__3EAg-","half":"SiteInfo_half__hIGaY"};